import React, { Fragment } from "react";

import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import { useTranslate } from "react-admin";

const ReferencePeriodField = ({ record }) => {
  const translate = useTranslate();
  const number = get(record, "number", 0);
  const fromDate = get(record, "from_date");
  const toDate = get(record, "to_date");

  let caption = translate("resources.substitutive-declarations.fields.number", {
    number: number,
  });

  return (
    <Fragment>
      <Typography>{caption}</Typography>
      <Typography variant="body2">
        {moment(fromDate).format(translate("app.date_format.short"))} -{" "}
        {moment(toDate).format(translate("app.date_format.short"))}
      </Typography>
    </Fragment>
  );
};
export default ReferencePeriodField;
